const { createClient } = supabase;

const client = createClient(
  "https://mifwwaikvumjurgraslk.supabase.co",
  "sb_publishable_MGFP0zVIAuJVfwfCAgPQ_A_WI82lx_B"
);

async function trackAddToCart(productName, variantName, qty) {

  const { data, error } = await client
    .from("add_to_cart")
    .insert([
      {
        product: productName,
        variant: variantName,
        quantity: qty
      }
    ]);

  if(error){

    console.error("Supabase Error:", error);

  } else {

    console.log("Cart tracked successfully");

  }

}

document.addEventListener("click", async function(e){

  const button = e.target.closest('button');

  if(!button) return;

  let productName = "Unknown Product";

  // Quick View Modal (highest priority)
  const quickViewTitle =
    document.querySelector(
      '.popup-quick-view__title a'
    )?.innerText?.trim();

  if(quickViewTitle){

    productName = quickViewTitle;

  }

  // Collection Product Card
  else {

    const productCard =
      button.closest('.card-wrapper, .grid__item, .product-card');

    if(productCard){

      const titleElement =
        productCard.querySelector(
          '.card__heading, .full-unstyled-link'
        );

      if(titleElement){

        productName =
          titleElement.innerText.trim();

      }

    }

    // Product Page Fallback
    if(
      productName === "Unknown Product" &&
      window.meta?.product?.title
    ){

      productName =
        window.meta.product.title;

    }

  }

  const variantName =
    document.querySelector('input[name="id"]')?.value ||
    "Default Variant";

  await trackAddToCart(
    productName,
    variantName,
    1
  );

});